import type { IWizardStep } from "@/types/ComponentLibrary/component-library";
import { defineComponent } from "vue";

export default defineComponent({
  name: "Wizard",
  data() {
    return {
      steps: [] as Array<IWizardStep>,
      currentStep: {} as any,
    };
  },
  created() {
    window.FormEngine.form.registerWizard(this);
    let wizSteps = [] as Array<IWizardStep>;
    let stepIndex = 0;
    for (let controlName in window.FormEngine.structure.structureJSON.tree) {
      let structureField = window.FormEngine.structure.structureJSON.tree[controlName] as ITreeField;

      wizSteps.push({ Id: structureField.Identifier, Label: structureField.Name as string });
    }
    window.FormEngine.events.subscribe(window.FormEngine.events.list.VUE_AFTER_MOUNT, function (temp: any) {
      window.FormEngine.form.wizard.setCurrentStep(window.FormEngine.form.wizard.steps[0].Id);
    });
    this.steps = wizSteps;
  },
  methods: {
    setCurrentStep(identifier: string) {
      this.hideAllSteps();
      let targetable = window.FormEngine.form.getTargetable(identifier);
      targetable.show();
      window.FormEngine.form.wizard.currentStep = targetable;
    },
    hideAllSteps() {
      this.steps.forEach(function (step, index) {
        let targetable = window.FormEngine.form.getTargetable(step.Id);
        targetable.hide();
      });
    },
    navigateToStep(step: IWizardStep) {
      this.setCurrentStep(step.Id);
    },
  },
});
